import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services';
import { Observable } from 'rxjs';
import { ReservationsFiltersReportCreate } from '../models/reservations-filters-report.model';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ReportReservationsFiltersService {
  private apiService = inject(ApiService);
  private readonly apiUrl: string = environment.apiUrl;
  private http = inject(HttpClient);
  private pipe = new DatePipe('en-US');

  getReportReservationsFilters(
    formData: ReservationsFiltersReportCreate,
    size?: string
  ): Observable<any> {
    if (size == undefined) {
      size = '100000';
    }

    try {
      if (formData.startDate) {
        formData.startDate =
          this.convertirFecha(formData.startDate) + ' 00:00:00';
      }

      if (formData.endDate) {
        formData.endDate = this.convertirFecha(formData.endDate) + ' 23:59:59';
      }
    } catch {
      formData.startDate =
        this.pipe.transform(formData.startDate, 'dd-MM-yyyy')?.toString() +
        ' 00:00:00';

      formData.endDate =
        this.pipe.transform(formData.endDate, 'dd-MM-yyyy')?.toString() +
        ' 23:59:00';
    }
    const create = this.createTexteQuery(formData);
    return this.apiService.getAll(
      `report/getReservationsByFilters?${create}&page=0&size=${size}`
    );
  }

  convertirFecha(fechaOriginal: string) {
    // Parsear la cadena a un objeto Date

    console.log('Fecha original', fechaOriginal);
    const partesFechaHora = fechaOriginal.split(' ');

    // Obtener solo la parte de la fecha (dd-MM-yyyy)
    const fechaPartes = partesFechaHora[0].split('-');

    const dia = fechaPartes[0]; // Día
    const mes = fechaPartes[1]; // Mes
    const anio = fechaPartes[2]; // Año

    // Formatear la fecha al formato "dd-MM-yyyy"
    const fechaFormateada = `${dia}-${mes}-${anio}`;

    return fechaFormateada;
  }

  getReportReservationsFiltersPdf(
    formData: ReservationsFiltersReportCreate,
    size?: string
  ): Observable<Blob | any> {
    if (size == undefined) {
      size = '100000';
    }
    try {
      if (formData.startDate) {
        formData.startDate =
          this.convertirFecha(formData.startDate) + ' 00:00:00';
      }

      if (formData.endDate) {
        formData.endDate = this.convertirFecha(formData.endDate) + ' 23:59:59';
      }
    } catch {
      formData.startDate =
        this.pipe.transform(formData.startDate, 'dd-MM-yyyy')?.toString() +
        ' 00:00:00';

      formData.endDate =
        this.pipe.transform(formData.endDate, 'dd-MM-yyyy')?.toString() +
        ' 23:59:00';
    }
    const create = this.createTexteQuery(formData);
    return this.http.get(
      `${this.apiUrl}report/getReservationsByFiltersPdf?${create}&page=0&size=${size}`,
      { responseType: 'blob' as 'json' }
    );
  }

  getReportReservationsFiltersCsv(
    formData: ReservationsFiltersReportCreate,
    size?: string
  ): Observable<Blob | any> {
    if (size == undefined) {
      size = '100000';
    }
    try {
      if (formData.startDate) {
        formData.startDate =
          this.convertirFecha(formData.startDate) + ' 00:00:00';
      }

      if (formData.endDate) {
        formData.endDate = this.convertirFecha(formData.endDate) + ' 23:59:59';
      }
    } catch {
      formData.startDate =
        this.pipe.transform(formData.startDate, 'dd-MM-yyyy')?.toString() +
        ' 00:00:00';

      formData.endDate =
        this.pipe.transform(formData.endDate, 'dd-MM-yyyy')?.toString() +
        ' 23:59:00';
    }
    const create = this.createTexteQuery(formData);
    return this.http.get(
      `${this.apiUrl}report/getReservationsByFiltersCsv?${create}&page=0&size=${size}`,
      { responseType: 'blob' as 'json' }
    );
  }

  private createTexteQuery(formData: ReservationsFiltersReportCreate) {
    let text = '';
    if (formData.startDate) {
      text += 'startDate=' + formData.startDate;
    }

    if (formData.endDate) {
      if (text) {
        text += '&endDate=' + formData.endDate;
      } else {
        text += 'endDate=' + formData.endDate;
      }
    }

    if (formData.workplaceTypeId) {
      if (text) {
        text += '&workplaceTypeId=' + formData.workplaceTypeId;
      } else {
        text += 'workplaceTypeId=' + formData.workplaceTypeId;
      }
    }
    if (formData.buildingId) {
      if (text) {
        text += '&buildingId=' + formData.buildingId;
      } else {
        text += 'buildingId=' + formData.buildingId;
      }
    }
    if (formData.floorId) {
      if (text) {
        text += '&floorId=' + formData.floorId;
      } else {
        text += 'floorId=' + formData.floorId;
      }
    }
    if (formData.workplaceId) {
      if (text) {
        text += '&workplaceId=' + formData.workplaceId;
      } else {
        text += 'workplaceId=' + formData.workplaceId;
      }
    }
    if (formData.worker) {
      if (text) {
        text += '&worker=' + formData.worker;
      } else {
        text += 'worker=' + formData.worker;
      }
    }
    if (formData.businessId) {
      if (text) {
        text += '&businessId=' + formData.businessId;
      } else {
        text += 'businessId=' + formData.businessId;
      }
    }
    if (formData.reservationStatusId) {
      if (text) {
        text += '&reservationStatusId=' + formData.reservationStatusId;
      } else {
        text += 'reservationStatusId=' + formData.reservationStatusId;
      }
    }
    return text;
  }
}
